var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf",class:_vm.cssClass,style:(_vm.cssStyle)},[_vm._t("default",function(){return [(_vm.isEditorMode)?_c('code',[_vm._v("default slot")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }